import { Pipe, PipeTransform } from '@angular/core';
import { formatPesosCop } from '../utils/currency-cop.util';

/** Formato visual pesos: $20.000.000 (igual que secciones de perfil / solicita crédito). */
@Pipe({
  name: 'pesosCop',
  standalone: false,
})
export class PesosCopPipe implements PipeTransform {
  transform(value: unknown): string {
    return formatPesosCop(value);
  }
}
